// extracted by mini-css-extract-plugin
export default {"padding":"Padding-module--padding--938b2"};